//get masthead ad config
export const GET_MASTHEAD_AD = "GET_MASTHEAD_AD";
